'use strict';Object.defineProperty(exports,"__esModule",{value:true});exports.default=Pane;var _react=require('react');var _react2=_interopRequireDefault(_react);var _propTypes=require('prop-types');var _propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Pane(props){return _react2.default.createElement('div',{'data-id':props.label},props.children);}Pane.propTypes={label:_propTypes2.default.string.isRequired,children:_propTypes2.default.oneOfType([_propTypes2.default.array,_propTypes2.default.element]).isRequired};module.exports=exports['default'];
//# sourceMappingURL=Pane.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/watson-react-components/dist/components/Tabs/Pane.js
// module id = 6852
// module chunks = 0